import React from 'react';
import { FormattedMessage } from 'react-intl';

import Modal from '@/components/atoms/Modal';
import { Button } from '@/components/atoms/Button';

type Props = {
    isOpen: boolean;
    restaurantCount?: number;
    onConfirm: () => void;
    onCancel: () => void;
};

export const ConfirmReloadModal: React.FC<Props> = ({ isOpen, restaurantCount, onConfirm, onCancel }) => {
    const buttons = (
        <Button buttonType="primary" onClick={onConfirm}>
            <FormattedMessage id="promotionalBanner.confirm.confirm" />
        </Button>
    );

    return (
        <Modal isOpen={isOpen} onHide={onCancel} title="promotionalBanner.confirm.title" buttons={buttons}>
            {restaurantCount != null ? (
                <FormattedMessage id="promotionalBanner.confirm.message.bulk" values={{ count: restaurantCount }} />
            ) : (
                <FormattedMessage id="promotionalBanner.confirm.message" />
            )}
        </Modal>
    );
};
